import { Link } from "react-router-dom";
import { Home, LayoutGrid, Tag, ShoppingBag } from "lucide-react";
import { useCart } from "@/context/Providers";

export const MobileBar = () => {
  const { count, setOpen } = useCart();
  const item = "flex flex-1 flex-col items-center justify-center gap-1 text-[11px] font-semibold text-gray-300";
  return (
    <nav aria-label="Quick actions" className="fixed inset-x-0 bottom-0 z-40 flex h-16 border-t border-line bg-ink/95 backdrop-blur-md lg:hidden" data-testid="mobile-action-bar">
      <Link to="/" className={item} data-testid="mobile-bar-home"><Home className="h-5 w-5" aria-hidden />Home</Link>
      <Link to="/shop/" className={item} data-testid="mobile-bar-shop"><LayoutGrid className="h-5 w-5" aria-hidden />Menu</Link>
      <Link to="/deals/" className={item} data-testid="mobile-bar-deals"><Tag className="h-5 w-5" aria-hidden />Deals</Link>
      <button type="button" onClick={() => setOpen(true)} className={`${item} relative`} data-testid="mobile-bar-cart">
        <ShoppingBag className="h-5 w-5" aria-hidden />Cart{count > 0 && <span className="absolute right-[28%] top-2 grid h-4 min-w-4 place-items-center rounded-full bg-gold px-1 text-[10px] text-ink">{count}</span>}
      </button>
    </nav>
  );
};
